import { Theme } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme & { legacy?: boolean }) => ({
  container: {
    alignItems: 'center',
  },
  avatar: {
    '&.large': {
      height: '24px',
      width: '24px',
    },

    '&.medium': {
      height: '22px',
      width: '22px',
    },

    '&.small': {
      height: '20px',
      width: '20px',
    },
  },
  name: {
    height: '100%',
    wordBreak: 'break-word',

    '&.large': {
      fontSize: theme.legacy ? '18px' : '16px',
    },

    '&.medium': {
      fontSize: '16px',
    },

    '&.small': {
      fontSize: '14px',
    },
  },
  underlineName: {
    textDecoration: 'underline',
  },
}));
